export const imageUrl = require('@/assets/images/technology/TextToSpeech/TextToSpeech-banner.png');
export const bannerText = '语音合成服务，通过先进的深度学习技术，将文本转换成自然流畅的语音。目前有多种音色可供选择，并提供调节语速、语调、音量等功能。适用于智能客服、语音交互、文学有声阅读和无障碍播报等场景。';
export const casesList = [{
  title: '同花顺',
  img_head: require('@/assets/images/technology/TextToSpeech/text-to-speech-case1.png'),
  img_icon: require('@/assets/images/technology/TextToSpeech/text-to-speech-case-icon.png')
}, {
  title: 'i问财',
  img_head: require('@/assets/images/technology/TextToSpeech/text-to-speech-case2.png'),
  img_icon: require('@/assets/images/technology/TextToSpeech/text-to-speech-case-icon.png')
}, {
  title: '电话应答',
  img_head: require('@/assets/images/technology/TextToSpeech/text-to-speech-case3.png'),
  img_icon: require('@/assets/images/technology/TextToSpeech/text-to-speech-case-icon.png')
}];
export const applicationsList = [{
  title: '智能客服',
  desc: '利用语音合成赋予机器人说话能力，直接回答客户的问题。',
  img: require('@/assets/images/technology/TextToSpeech/text-to-speech-app1.png')
}, {
  title: '车载导航',
  desc: '合成个性化语音提供实时导航信息。',
  img: require('@/assets/images/technology/TextToSpeech/text-to-speech-app2.png')
}, {
  title: '文字阅读',
  desc: '听书，换一种阅读方式。',
  img: require('@/assets/images/technology/TextToSpeech/text-to-speech-app3.png')
}, {
  title: '广告宣传',
  desc: '定制化合成电视、电话广告语音，省去人工录音的烦恼。',
  img: require('@/assets/images/technology/TextToSpeech/text-to-speech-app4.png')
}];
export const adsListLeft = [{
  title: '合成效果个性化配置',
  desc: '支持语速、语调、音量的个性化配置'
}, {
  title: '多种格式输出',
  desc: '支持wav、mp3文件格式，8K、16K采样率的输出方式'
}];
export const adsListRight = [{
  title: '支持多格式输入',
  desc: '支持wav、mp3、aac、m4a多格式输入识别'
}, {
  title: '更多特色服务',
  desc: '支持说话人区分、情绪识别、性别判断等功能'
}];